import React, { Component } from 'react';
import { supportLink } from '../../config';
import { UnifiedLayout } from '../../layouts/UnifiedLayout/UnifiedLayout';
import { Divider, Header } from '@solarwindscloud/nighthawk-ui';
import { ROUTES } from '@solarwindscloud/sso-nighthawk-shared';
import { Link } from 'react-router-dom';

export const dataTestIds = {
  missingOrg: 'missing-org',
  contactSupport: 'contact-support',
  linkToSignup: 'sign-up',
};

export default class MissingOrg extends Component {
  render() {
    return (
      <UnifiedLayout
        headerText="No Organization for the User Account"
        dataTestId={dataTestIds.missingOrg}
        dataTestPageName="MissingOrg"
      >
        <Header textAlign="center">
          <Header.Subheader>
            There is no organization associated with your user account.
            <Divider hidden />
            You can{' '}
            <Link to={{ pathname: ROUTES.EXTERNAL_SIGN_UP }} data-test-id={dataTestIds.linkToSignup}>
              sign up
            </Link>{' '}
            with a different e-mail or{' '}
            <a href={supportLink} data-test-id={dataTestIds.contactSupport}>
              contact our support team
            </a>{' '}
            to <br />
            continue with the current e-mail address.
          </Header.Subheader>
        </Header>
      </UnifiedLayout>
    );
  }
}
